// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"76753a91249ee438e8da","147":"2b0817051a61b16660f2","251":"b6b84b7b53105ae2582b","352":"f3ca72e6dd75c2bb2e6f","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};